import { MoneyInput } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export type PaymentApplyToBillParams = {
  paymentId: string;
  billId: string;
  appliedAmount: MoneyInput;
};

export const paymentApplyToBillAtom = createMutationAtomFactory(
  'finance.paymentApplyToBill',
  (params: PaymentApplyToBillParams) => ({
    financePaymentApplyToBill: {
      __args: {
        input: {
          paymentId: params.paymentId,
          billId: params.billId,
          appliedAmount: params.appliedAmount,
        },
      },
      id: true,
      documentNumber: true,
      status: true,
      amount: {
        amount: true,
        currencyCode: true,
      },
      bills: {
        bill: {
          id: true,
          documentNumber: true,
        },
        appliedAmount: {
          amount: true,
          currencyCode: true,
        },
        appliedAt: true,
      },
      timestamps: {
        updatedAt: true,
      },
    },
  }),
);
